<div class="header">
    <div class="logo"></div>
    <a class="facebook" href="https://www.facebook.com/APROMAR-81218981562/"></a>
    <a class="twitter"></a>
    <div class="desplegable_menu" (click)="toggleMenu()"></div>
</div>
<div class="menu" [ngClass]="{'menu-shown': showMenu}">
    <div class="menu-content">
        <!--<a ui-sref-active="active" ui-sref="home" href="/home">INICIO</a>-->
        <a ui-sref-active="active" ui-sref="about_us" href="/about-us">QUIÉNES SOMOS</a>
        <a ui-sref-active="active" ui-sref="ir" href="/institutional-relations">FINANCIACIÓN Y RELACIONES INSTITUCIONALES</a>
        <a ui-sref-active="active" ui-sref="project" href="/project">PROYECTO</a>
        <a ui-sref-active="active" ui-sref="quality-policy" href="/quality-policy">POLÍTICA DE CALIDAD</a>
        <a ui-sref-active="active" ui-sref="collaborate" href="/collaborate">COLABORA</a>
        <!--<a ui-sref-active="active" ui-sref="news" href="/news">NOTICIAS</a>-->
        <!--<a ui-sref-active="active" ui-sref="articles" href="/articles">ARTÍCULOS</a>
        <a ui-sref-active="active" ui-sref="media" href="/media">EN LOS MEDIOS</a>-->
    </div>
</div>